import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';

import './otp-verification-modal-style.scss';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

import useTimer from '@src/hooks/useTimer';
import useMobileOtp from '@src/hooks/useOTPVerification';

interface IProps {
  open: boolean;
  onClose?: any;
}

const OTPVerificationModal = ({ open, onClose }: IProps) => {
  const [step, setStep] = useState('0');
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [showMessage, setShowMessage] = useState('');

  const { time, startTimer } = useTimer(60);
  const { handleRequestOtp, handleVerifyOtp } = useMobileOtp({ setStep, time, startTimer, setShowMessage });

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;

    const isValidInput = /^\d{0,10}$/.test(value);

    if (isValidInput) {
      setMobileNumber(value);
    }
  };

  const handleOTPChange = (e) => {
    const value = e.target.value;

    const isValidInput = /^\d{0,6}$/.test(value);

    if (isValidInput) {
      setOtp(value);
    }
  };

  const handleActionBtnClick = () => {
    if (step === '0') {
      setStep('1');
    } else if (step === '1') {
      handleRequestOtp(mobileNumber);
    } else if (step === '2') {
      handleVerifyOtp(otp, mobileNumber);
    }
  };

  return (
    <Modal open={open} onClose={onClose} onClick={(e) => e.stopPropagation()}>
      <div className="otp-verification-modal-content">
        <Typography variant="subtitle1" component="span" style={{ color: '#212121' }}>
          {step === '0'
            ? 'OTP Verification Required'
            : step === '1' || step === '2'
            ? 'OTP Verification'
            : 'Verification Complete'}
        </Typography>

        <Typography cName="info-text" variant="body3" component="p" style={{ color: '#212121' }}>
          {step === '0'
            ? 'Please verify your mobile number\nto get a restock notification'
            : step === '1'
            ? 'We will send you an OTP number on\nthis mobile number'
            : step === '2'
            ? `Enter the OTP you received on\n+91 ${mobileNumber}`
            : 'Now you can receive all the notifications\nvia message.'}
        </Typography>

        {(step === '1' || step === '2') && (
          <div className="input-wrapper">
            <TextField
              size="medium"
              className="custom-input"
              label={step === '1' ? 'Mobile Number' : 'OTP'}
              placeholder={step === '1' ? '+ 91' : 'OTP'}
              value={step === '1' ? mobileNumber : otp}
              // disabled={loading}
              onChange={step === '1' ? handleMobileNumberChange : handleOTPChange}
              fullWidth
            />
            {showMessage ? (
              <Typography cName="result-text" variant="body3" component="p">
                {showMessage}
              </Typography>
            ) : null}
          </div>
        )}

        {step === '2' && (
          <Typography variant="subtitle2" component="span" style={{ color: '#F82296' }}>
            {String(time.minutes).padStart(2, '0')}:{String(time.seconds).padStart(2, '0')}
          </Typography>
        )}

        <div className="btn-wrapper">
          {step === '0' && (
            <>
              <Button size="medium" variant="contained" onClick={onClose}>
                Cancel
              </Button>
              <Button size="medium" variant="contained" onClick={handleActionBtnClick}>
                Verify
              </Button>
            </>
          )}
          {step === '1' && (
            <Button size="medium" variant="contained" onClick={handleActionBtnClick}>
              Continue
            </Button>
          )}
          {step === '2' && (
            <>
              <Button size="medium" variant="contained" onClick={() => handleRequestOtp(mobileNumber)}>
                Resend
              </Button>
              <Button size="medium" variant="contained" onClick={handleActionBtnClick}>
                Verify
              </Button>
            </>
          )}
          {step === '3' && (
            <Button size="medium" variant="contained" onClick={onClose}>
              Close
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default OTPVerificationModal;
